import axios from "axios";
import Globals from "@/globals.js";

const ApiClient = axios.create({
  baseURL: Globals.apiUrl,
  withCredentials: false, // This is the default
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default ApiClient;
